import React from 'react'
import styles from './Guests.scss'
import { connect } from 'react-redux'
import { getExperienceId } from '../ExperiencesApp/ExperiencesApp'
import { QuickStats } from '../QuickStats'
import { experienceApi, experienceSelectors, experienceActions } from 'data/resources/experiences'
import { appCodeSelectors } from 'data/resources/appCodes'
import { appCodeUseSelectors, appCodeUseActions } from 'data/resources/appCodeUses'
import { CTA } from 'common/styleguide/CTA'
import { Icon } from 'common/Icon'
import { SectionBox } from 'common/styleguide/SectionBox'
import moment from 'moment'
import Helmet from 'react-helmet'

export class _Guests extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      stats: null
    }
  }

  loadData () {
    const { loadExperience, loadAppCodeUses } = this.props
    const experienceId = getExperienceId(this.props)

    loadExperience()
    experienceApi.stats(experienceId)
      .then(({ stats }) => { this.setState({ stats }) })
    loadAppCodeUses()
  }

  componentDidMount () {
    this.loadData()
  }

  componentDidUpdate (prevProps) {
    if (getExperienceId(prevProps) !== getExperienceId(this.props)) {
      this.loadData()
    }
  }

  onExpiredChange = (e) => {
    const { expireGuest, unexpireGuest } = this.props
    const id = +e.target.value

    e.target.checked ? expireGuest(id) : unexpireGuest(id)
  }

  render () {
    const { experience, appCode, appCodeUses } = this.props
    const { stats } = this.state
    const now = new Date()
    const detail = (appCodeUse, key) => (appCodeUse.requestedDetails ? appCodeUse.requestedDetails[key] : '')

    return (
      <div className={styles.Guests}>
        {experience && <Helmet title={experience.name} />}
        <div className={styles.top}>
          <QuickStats totals={stats} className={styles.statsContainer} />
          {experience && appCodeUses && <CTA
            secondary
            margins={false}
            href={`/app_code_uses.csv?parent_type=Experience&parent_id=${experience.id}`}
            className={styles.aSpecificity}>
            <Icon i='md-download' size={20} />Export CSV
          </CTA>}
        </div>
        <SectionBox title='Guests' noPadding>
          {experience && appCodeUses && (
            <table className={styles.guestsTable}>
              <thead>
                <tr>
                  <th>Date Accessed</th>
                  <th>Shortcut Used</th>
                  {experience.requireName && <th>First name</th>}
                  {experience.requireName && <th>Last name</th>}
                  {experience.requireEmail && <th>Email address</th>}
                  {experience.requirePhone && <th>Phone number</th>}
                  {experience.requireReferenceId && <th>Reference ID</th>}
                  {experience.requireZipCode && <th>Zip code</th>}
                  <th>Expired</th>
                  <th>Expiration date</th>
                </tr>
              </thead>
              <tbody>
                {appCodeUses.map(appCodeUse => (
                  <tr key={appCodeUse.id}>
                    <td>{moment(appCodeUse.createdAt).format('MMM D, YYYY [at] h:mma')}</td>
                    <td>{appCode(appCodeUse.appCodeId)?.code}</td>
                    {experience.requireName && <td>{detail(appCodeUse, 'first_name')}</td>}
                    {experience.requireName && <td>{detail(appCodeUse, 'last_name')}</td>}
                    {experience.requireEmail && <td>{detail(appCodeUse, 'email')}</td>}
                    {experience.requirePhone && <td>{detail(appCodeUse, 'phone')}</td>}
                    {experience.requireReferenceId && <td>{detail(appCodeUse, 'reference_id')}</td>}
                    {experience.requireZipCode && <td>{detail(appCodeUse, 'zip_code')}</td>}
                    <td>
                      <input type='checkbox' onChange={this.onExpiredChange} value={appCodeUse.id}
                        checked={!!appCodeUse.expiresAt && moment(appCodeUse.expiresAt).isSameOrBefore(now)} />
                    </td>
                    <td>
                      {!appCodeUse.expiresAt && 'Never'}
                      {appCodeUse.expiresAt && moment(appCodeUse.expiresAt).format('MMM D, YYYY [at] h:mma')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </SectionBox>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    loadExperience: () => dispatch(experienceActions.read(experienceId)),
    loadAppCodeUses: () => dispatch(appCodeUseActions.list({ parentType: 'Experience', parentId: experienceId, extras: 'app_codes' })),
    expireGuest: appCodeUseId => dispatch(experienceActions.expireGuest(experienceId, { appCodeUseId })),
    unexpireGuest: appCodeUseId => dispatch(experienceActions.unexpireGuest(experienceId, { appCodeUseId }))
  }
}

const mapStateToProps = (state, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    experience: experienceSelectors.find(state, experienceId),
    appCode: acId => appCodeSelectors.find(state, acId),
    appCodeUses: appCodeUseSelectors.findByIds(state, appCodeUseSelectors.byParent(state, 'Experience', experienceId))
  }
}

export const Guests = connect(
  mapStateToProps,
  mapDispatchToProps
)(_Guests)
